module.exports = __webpack_public_path__ + "img/partnerBlue.5a3922ff.jpg";